module.exports = __webpack_public_path__ + "static/media/tip_background.055e87b8.png";